export default function(callback) {
  return (event, ...rest) => {
    event.preventDefault();
    callback(event, ...rest);
  };
}
